var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('polygon',{attrs:{"points":_vm.hexCorners.map(function (p) { return ((p.x) + "," + (p.y)); }).join(' '),"id":"space-hex"}})}
var staticRenderFns = []

export { render, staticRenderFns }